export default class BaseExcelWriter {
    constructor(languageCodes, keyMacro, valueMacro) {
        this.languageCodes = languageCodes;
        this.keyMacro = keyMacro;
        this.valueMacro = valueMacro;
        this.files = [];
    }
}